import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConnectionDB } from 'src/app/interfaces/connectionDb';
import { URL } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigurationDbModalService {
  private readonly http = inject(HttpClient);

  /**************************************************************************👌
   * Add a connection.                                                        *
   * @param applicationId The ID of the application to add the connection to  *
   * @param connection The connection to add.                                *
   * @returns An Observable of void.                                          *
   * **************************************************************************/
  addConnection(applicationId: number, connection: ConnectionDB): Observable<void> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(connection);
    return this.http.put<void>(`${URL.url}${URL.applications}${applicationId}/connection`, body, { headers });
  }

  /*******************************************************************👌
   * Update a connection.                                              *
   * @param connectionId The ID of the connection to update.           *
   * @param connection The updated connection.                         *
   * @returns An Observable of void.                                   *
   ********************************************************************/
  updateConnection(connectionId: number, connection: ConnectionDB): Observable<void> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(connection);
    return this.http.put<void>(`${URL.url}${URL.connectionsDb}${connectionId}`, body, { headers });
  }
}
